module.exports = __webpack_public_path__ + "static/media/bk_180.f8c3d715.svg";